export default __webpack_public_path__ + "static/media/Vacuum-Category-Offer.c669572b.png";